export enum CalendarViewMode {
    YEAR,
    MONTH,
    WEEK,
}
